import React from 'react';

import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';

import SocialIcons from './SocialIcons';

export default (props) => {
  return (
    <div className="footer">
      <Container>

        <Grid container direction="row" justify="space-between">
          <Grid item>
            <div style={{ paddingBottom: "5px" }}><SocialIcons /></div>
            <div style={{ paddingBottom: "2px" }}><h3 style={{ marginBottom: "0" }}><a href="https://www.corrivium.com" target="_blank" rel="noopener noreferrer">Your Brand</a></h3></div>
            <div><a href="https://twitter.com/search?q=corrivium" target="_blank" rel="noopener noreferrer">#WeAreLive</a></div>
            <div><a href="https://www.corrivium.com" target="_blank" rel="noopener noreferrer">www.corrivium.com</a></div>
          </Grid>
          <Grid item>
            <div style={{ paddingBottom: "3px", paddingTop: "50px" }}><h4 style={{ marginBottom: "0" }}>&copy; Copyright 2020 - <a href="https://www.corrivium.com" target="_blank" rel="noopener noreferrer">Corrivium Live</a></h4></div>
            <div>All Rights Reserved</div>
            <div><h4><a href="https://www.corrivium.com/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a></h4></div>
          </Grid>
        </Grid>


      </Container>
    </div>
  );
}


